var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.config.visible
    ? _c(
        "div",
        { staticClass: "modal-bg" },
        [
          _c(
            "AppDialog",
            {
              attrs: {
                title: "助手发布",
                width: "360px",
                "append-to-body": false,
                "custom-class": "amap-sug-result",
                loading: _vm.loading,
                height: "auto",
                top: _vm.top,
              },
              on: { success: _vm.sure },
              model: {
                value: _vm.config.visible,
                callback: function ($$v) {
                  _vm.$set(_vm.config, "visible", $$v)
                },
                expression: "config.visible",
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "publicDialog",
                },
                [
                  _vm.config.visible
                    ? _c("div", { staticClass: "aiDetail" }, [
                        _vm.config.row.icon
                          ? _c(
                              "div",
                              { staticClass: "ailist_view_img" },
                              [
                                _vm.config.row.type === 1
                                  ? _c("img", {
                                      attrs: {
                                        src: require("@/assets/image/aigc/my_icon.png"),
                                        alt: "",
                                      },
                                    })
                                  : [
                                      !!_vm.config.row.icon
                                        ? _c("img", {
                                            attrs: {
                                              src: _vm.config.row.icon,
                                              alt: "",
                                            },
                                          })
                                        : _c(
                                            "div",
                                            {
                                              staticClass: "title-span",
                                              style: {
                                                background:
                                                  _vm.config.row
                                                    .backgroundColor,
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  style: {
                                                    color:
                                                      _vm.config.row.textColor,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.config.row.title.split(
                                                        ""
                                                      )[0]
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                    ],
                              ],
                              2
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "ailist_detail" }, [
                          _c("div", { staticClass: "ailist_detail_title" }, [
                            _vm._v(_vm._s(_vm.config.row.title)),
                          ]),
                          _c("div", { staticClass: "ailist_detail_describe" }, [
                            _vm._v(_vm._s(_vm.config.row.describe)),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "ss-material-box-bottom",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        loading: _vm.loading,
                        type: "primary",
                      },
                      on: { click: _vm.sure },
                    },
                    [_vm._v("确定发布")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }